import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CreateViewRequest, View } from '../../types/View';
import { defaultView } from '../../utils/defaultView';
import {
    requestCreateView,
    requestDeleteView,
    requestUpdateView,
    requestViews,
} from '../views/views';

export function useGetViews() {
    return useQuery({
        queryKey: ['views'],
        queryFn: async ({ signal }) => {
            const data = (await requestViews(signal)).data;
            return [defaultView, ...data];
        },
    });
}

export function useCreateView() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (view: CreateViewRequest) => (await requestCreateView(view)).data,
        onSuccess: async data => {
            queryClient.invalidateQueries({ queryKey: ['views'] });
        },
    });
}

export function useUpdateView() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (view: View) => (await requestUpdateView(view)).data,
        onSuccess: async data => {
            queryClient.invalidateQueries({ queryKey: ['views'] });
            queryClient.invalidateQueries({ queryKey: ['groups'] });
        },
    });
}

export function useDeleteView() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (viewId: number) => (await requestDeleteView(viewId)).data,
        onSuccess: async data => {
            queryClient.invalidateQueries({ queryKey: ['views'] });
        },
    });
}
